export enum OrderPaymentStatusEnum {
  unpaid = 'Unpaid',
  partiallyPaid = 'Partially Paid',
  paid = 'Fully Paid',
  overPaid = 'Over Paid',
  notReceivable = 'Not Receivable',
}
